<div class="tabbed-content font-body bg-cover {{ theme?.root }}">
  <!-- SEO-optimized hidden content for crawlers -->
  @if (isSeoOptimizationEnabled) {
    <div class="sr-only">
      @for (tab of tabs; track tab; let tabIndex = $index) {
        <div>
          <h2 [innerText]="getCleanTabTitle(tab.tabTitle)"></h2>
          @if (tab.accordion?.accordionItems) {
            <div>
              @for (item of tab.accordion.accordionItems; track item) {
                <div itemscope itemtype="https://schema.org/Question">
                  <h3 itemprop="name" [innerText]="getCleanText(item.itemTitle)"></h3>
                  <div itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer">
                    <div itemprop="text" [innerHTML]="getCleanHtml(item.itemDescription)"></div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="container {{ theme?.container }}">
    @if (tabbedContentTitle) {
      <div
        class="wysiwyg py-v-spacing sm:p-v-spacing max-w-container mx-auto text-center"
        [innerHTML]="tabbedContentTitle"
      ></div>
    }
    @if (tabs && tabs.length > 1) {
      <nav
        class="tabbed-content__cta-wrapper py-v-spacing sm:p-v-spacing max-w-container flex mx-auto justify-center items-stretch"
        role="tablist"
        [attr.aria-label]="getAriaLabel()"
        >
        @for (tabItem of tabs; track tabItem; let index = $index; let first = $first; let last = $last) {
          <button
        class="
          grow
          justify-center
          items-center
          tabbed-content-cta
          py-v-spacing
          sm:p-v-spacing
          wysiwyg
          {{ index !== activeIndex && tabs.length > 1 ? data.styles + ' hover:font-bold' : '' }}
          {{ tabs.length > 2 ? 'hidden lg:block' : '' }}
          {{
          (data?.backgroundColor && data?.backgroundColor.includes('text-white')) ||
          (data?.styles && data?.styles.includes('text-vis-reverse'))
            ? 'text-vis-reverse'
            : 'text-ace-teal-800'
        }}
        "
            role="tab"
            [attr.aria-selected]="index === activeIndex"
            [attr.aria-controls]="'tabpanel-' + index"
            [attr.id]="'tab-' + index"
            [attr.tabindex]="index === activeIndex ? 0 : -1"
            (click)="selectTab(index)"
            (keydown)="onKeyDown($event, index)"
        [ngClass]="{
          '!font-extrabold': index === activeIndex && tabs.length > 1,
          'text-vis-reverse dark-active-tab':
            index === activeIndex &&
            tabs.length > 1 &&
            ((data?.backgroundColor && data?.backgroundColor.includes('text-white')) ||
              (data?.styles && data?.styles.includes('text-vis-reverse'))),
          'text-ace-teal-800 active-tab':
            index === activeIndex &&
            tabs.length > 1 &&
            !(
              (data?.backgroundColor && data?.backgroundColor.includes('text-white')) ||
              (data?.styles && data?.styles.includes('text-vis-reverse'))
            ),
          'cursor-pointer rounded-md': tabs.length > 1
        }"
            [innerHTML]="tabItem.tabTitle"
          ></button>
        }
        @if (tabs.length > 2) {
          <div class="p-v-spacing w-full select-container lg:hidden bg-ace-grey-400 rounded-md">
            <div class="rounded-md border border-vis-muted bg-ace-grey-100">
              <select
                class="text-sm w-full rounded-md cursor-pointer select-none h-auto bg-ace-grey-100 text-vis-regular"
                (change)="onChange($event.target.value)"
                [(ngModel)]="activeIndex"
                [attr.aria-label]="'Select tab content'"
                >
                @for (tabItem of tabs; track tabItem; let i = $index) {
                  <option [value]="i" [innerHTML]="tabItem.tabTitle"></option>
                }
              </select>
            </div>
          </div>
        }
      </nav>
    }
    @for (tabItem of tabs; track tabItem; let index = $index) {
      <section
        class="tabbed-content__tab-wrapper py-v-spacing sm:p-v-spacing max-w-container mx-auto"
        [class.hidden]="index !== activeIndex"
        role="tabpanel"
        [attr.id]="'tabpanel-' + index"
        [attr.aria-labelledby]="'tab-' + index"
        [attr.aria-hidden]="index !== activeIndex"
        >
        @if (tabItem.showContent) {
          <accordion
            class="tabbed-content__tab -mt-6 block"
            [data]="tabItem.accordion"
            isChild="true"
          ></accordion>
        }
      </section>
    }
  </div>
</div>
